import React from 'react';
import { Form } from 'react-bootstrap';

import {
  CreateUpdateCompanyDto,
  CreateUpdateCompanyDtoLanguageEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import { UploadImageFile } from '../../../common/components/File/UploadImageFile';
import { LanguageSelector } from '../Selects/LanguageSelector';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface CompanyVisualDataTabProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  setFile: (logo: string) => void;
}

export const CompanyVisualDataTab: React.FC<CompanyVisualDataTabProps> = ({
  company,
  propertyChange,
  setFile,
}) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="language" label={t(tk.administration.language)}>
        <LanguageSelector
          value={company.language}
          onChange={options =>
            propertyChange({
              language: options.value as CreateUpdateCompanyDtoLanguageEnum,
            })
          }
          withName={true}
        />
      </FormRow>

      <FormRow controlId="color" label={t(tk.administration.color)}>
        <Form.Control
          type="color"
          value={company?.color || '#ffffff'}
          onChange={e => propertyChange({ color: e.target.value })}
        />
      </FormRow>

      <FormRow
        controlId="logo"
        label={t(tk.administration.logo)}
        className="mt-3"
      >
        <UploadImageFile
          file={company.logo}
          setFile={setFile}
          imageHeight={50}
          buttonText={t(tk.administration.uploadGraphicFile)}
        />
      </FormRow>
      <FormRow
        controlId="stamp"
        label={t(tk.administration.stamp)}
        className="mt-3"
      >
        <UploadImageFile
          file={company.stamp}
          setFile={stamp => propertyChange({ stamp })}
          imageHeight={80}
          buttonText={t(tk.administration.uploadGraphicFile)}
          requiredTransparent={true}
        />
      </FormRow>
    </Form>
  );
};
